import React from "react";
import { StyledDiv } from "./style";

export interface Props {
  open: boolean;
  handleClick: () => void;
}

const Backdrop: React.FC<Props> = ({ open, handleClick }) => {
  return (
    <div onClick={() => handleClick()} onKeyDown={() => handleClick()} role="presentation">
      <StyledDiv open={open} handleClick={handleClick} />
    </div>
  );
};

export default Backdrop;
